import React, {useEffect, useRef, useState} from "react";
import {Button, Card, Col, List, message, Row, Tag, Tooltip} from "antd";
import {getSubscriptionUrl} from "../../api/stripeSubscription"
import HttpError from "../base/HttpError";
import {useLocation} from "react-router";
import {URL_SIGNUP, URL_SUBSCRIPTION, URL_SUBSCRIPTION_CANCEL, URL_SUBSCRIPTION_FAILED} from "../../const";
import {IN_PRODUCT} from "../../config/product";
import {submitClickSubscribeHubspotForm} from "../../api/hubspot";

const {Meta} = Card

const CheckIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="green"
            viewBox="0 4 18 24"
        >
            <path
                css={{
                    fill: '$green600',
                }}
                d="m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"
            ></path>
        </svg>
    );
};

export const NotCheckedIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 14 24"
        >
            <path
                stroke="#f00"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
            ></path>
        </svg>
    );
};

function SubscriptionPlan(props) {
    const [cardHeight, setCardHeight] = useState(0)
    const [colHeight, setColHeight] = useState(0)
    const [loading, setLoading] = useState(false)
    const colRef = useRef(null)
    const location = useLocation()

    useEffect(() => {
        if (colHeight === 0) {
            setColHeight(colRef.current.clientHeight)
        }
        if (cardHeight !== colHeight) {
            setCardHeight(colRef.current.clientHeight)
        }
        if (location && location.pathname.toString().indexOf((URL_SUBSCRIPTION_CANCEL)) !== -1) {
            message.warn("Subscription failed, and you might cancel it.").then(() => {
            })
        }
        if (location && location.pathname.toString().indexOf((URL_SUBSCRIPTION_FAILED)) !== -1) {
            HttpError("Subscription failed, please contact contact@revart.co.")
        }
    }, [colRef])

    const handleOk = async () => {
        const plan = {
            "plan": props.plan,
            "period": props.paymentPeriod,
            "is_test": !IN_PRODUCT,
            'is_artist': props.is_artist ?? true
        }
        setLoading(true)
        try {
            if (IN_PRODUCT) {
                await submitClickSubscribeHubspotForm(
                    '9484c820-6cad-4bfd-b668-117217596b81',
                    [
                        {
                            objectTypeId: '0-1',
                            name: 'email',
                            value: props.email
                        },
                        {
                            objectTypeId: '0-1',
                            name: 'message',
                            value: props.plan + " " + props.paymentPeriod
                        }
                    ],
                    URL_SUBSCRIPTION,
                    'SubscriptionPlan'
                )
            }
        } catch (e) {
            console.log(e)
        }
        getSubscriptionUrl(plan)
            .then((response) => {
                window.location.href = response.data.url
            })
            .catch((error) => {
                HttpError(error)
            }).finally(() => {
            setLoading(false)
        })
    }

    const typeTag = (item) => {
        if (item.type) {
            return <span style={{
                    display: 'block',
                    color: 'black',
                    fontWeight: 'bold',
                    marginTop: 12,
                    marginBottom: 12
            }}>{item.type}</span>
        }
        return null
    }

    const inPlanText = (item) => {
        const typeText = typeTag(item)
        return (
            <>
                {typeText}
                <Row style={{marginTop: "6px", width: "100%"}}>
                    <Col span={3} style={{height: "80%"}}>
                        <CheckIcon/>
                    </Col>
                    <Col span={21}>
                            <span
                                style={{
                                    display: 'inline-block',
                                    fontSize: 12,
                                }}
                            >
                                {item.text}
                            </span>
                    </Col>
                </Row>
            </>
        )
    }

    const notInPlanText = (item) => {
        const typeText = typeTag(item)
        return (
            <>
                {typeText}
                <Row style={{marginTop: "6px", width: "100%"}}>
                    <Col span={3} style={{height: "80%", color: 'red'}}>
                        <NotCheckedIcon/>
                    </Col>
                    <Col span={21}>
                            <span
                                style={{
                                    display: 'inline-block',
                                    fontSize: 12,
                                }}
                            >
                                {item.text}
                            </span>
                    </Col>
                </Row>
            </>
        )
    }

    const innerCard = () => {
        return (
            <Card size="large"
                  style={{
                      marginLeft: 'auto',
                      marginRight: 'auto'
                  }}
                  bodyStyle={{
                      height: (cardHeight < 10) ? "100%" : (cardHeight + 36),
                  }}
            >
                <Row justify='space-between' align='middle' justify='center' style={{marginBottom: "20px"}}>
                    <Meta
                        title={
                            <span
                                style={{
                                    display: 'inline-block',
                                    fontSize: 18,
                                    width: '100%',
                                }}
                            >
                                <b>{props.plan_name}</b>
                            </span>
                        }
                    />
                </Row>
                <Row justify='center'>
                    <span
                        style={{
                            display: 'inline-block',
                            fontSize: 14,
                            paddingTop: "4px"
                        }}
                    >
                        <b>{"$"}</b>
                    </span>
                    {props.paymentPeriod === "yearly" ? (
                         <>
                         <span
                            style={{
                                display: 'inline-block',
                                fontSize: props.price_yearly_discount? 16: 32,
                                marginRight: "10px",
                                textDecoration: props.price_yearly_discount? 'line-through': 'none'
                            }}
                        >
                            <b>{props.price_yearly} </b>
                        </span>
                            {props.price_monthly_discount && (
                                 <span
                                style={{
                                    display: 'inline-block',
                                    fontSize: 32,
                                    marginRight: "10px",
                                }}
                            >
                                <b>{props.price_yearly_discount} <Tag color={'#f50'}>-20%</Tag></b>
                            </span>
                            )}
                        </>
                    ) : (
                        <>
                         <span
                            style={{
                                display: 'inline-block',
                                fontSize: props.price_monthly_discount? 16: 32,
                                marginRight: "10px",
                                textDecoration: props.price_monthly_discount? 'line-through': 'none'
                            }}
                        >
                            <b>{props.price_monthly}</b>
                        </span>
                            {props.price_monthly_discount && (
                                 <span
                                style={{
                                    display: 'inline-block',
                                    fontSize: 32,
                                    marginRight: "10px",
                                }}
                            >
                                <b>{props.price_monthly_discount}  <Tag color={'#f50'}>-20%</Tag></b>
                            </span>
                            )}
                        </>
                    )}
                </Row>
                <Row justify='center' style={{marginTop: 12}}>
                    {props.paymentPeriod === "yearly" ? (
                        <span
                            style={{
                                display: 'inline-block',
                                fontSize: 14,
                                textAlign: 'center'
                            }}
                        >
                            per month, billed annually.
                        </span>
                    ) : (
                        <span
                            style={{
                                display: 'inline-block',
                                fontSize: 14,
                                textAlign: 'center'
                            }}
                        >
                            per month, billed monthly.
                        </span>
                    )}
                </Row>
                <Row>
                    {(props.buttonDisabled && !props.expired) ? (
                        <Tooltip placement="top" title={planDate()}>
                            <Row style={{width: '100%'}}>
                                <Button type="ghost" block onClick={handleOk}
                                        disabled
                                        style={{
                                            marginTop: 24,
                                            marginBottom: 4,
                                            width: '80%',
                                            borderRadius: 8,
                                            height: 42,
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                >
                                    Current Plan
                                </Button>
                            </Row>
                        </Tooltip>
                    ) : (
                        <Button type={props.most_popular? 'primary': 'ghost'} onClick={handleOk} loading={loading}
                                style={{
                                    marginTop: 24,
                                    marginBottom: 4,
                                    width: '80%',
                                    borderRadius: 8,
                                    height: 42,
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                        >
                            Get Started
                        </Button>
                    )}
                    <List
                        dataSource={props.benefits}
                        style={{marginBottom: "20px", marginTop: 12}}
                        renderItem={(item) => {
                            return item.inPlan ? (
                                inPlanText(item)
                            ) : notInPlanText(item)

                        }
                        }
                    >
                    </List>
                </Row>
            </Card>
        )
    }

    const planDate = () => {
        if(!props.plan_object) {
            return ""
        }
        const end_date = props.plan_object.plan_end
        const date = new Date(end_date);
        const dateString = date.toLocaleString(); // Convert to local time string
        return "Your plan will expire on "+dateString
    }

    return (
        <>
            <Col ref={colRef} type="flex" xs={24} sm={24} md={12} lg={8} style={{
                paddingRight: "10px", paddingLeft: "10px", height: "100% !important",
                maxWidth: 360, minWidth: 300
            }}>
                {props.most_popular && (
                    <div style={{
                        height: 32,
                        borderTop: '1px solid grey',
                        display: 'flex',
                        borderRadius: "12px 12px 0px 0px",
                        width: '100%',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        backgroundColor: '#0531ad'
                    }}>
                        <span style={{fontSize: 10, color: 'white', marginLeft: 'auto', marginRight: 'auto'}}>MOST POPULAR</span>
                    </div>
                )}
                {!props.most_popular && (
                    <div style={{height: 32, width: '100%'}}/>
                )}
                {innerCard()}
            </Col>
        </>
    )
}

export default SubscriptionPlan